'use strict';

require("../styles/bloccaschermo.scss");

var bssbloccaschermo = angular.module("bss.bloccaschermo", [])        
    .service("Bloccaschermo", ["$rootScope", require("./Bloccaschermo")])
    .directive("bssscreensaver", ['Bloccaschermo', require("./BloccaSchermoDir")])
;

module.exports = bssbloccaschermo;